import moment from 'moment';
import { Chip } from '@mui/material';
import { NotificationType } from '../../types/notifications';

export const NOTIFICATION_TYPES: { label: string; value: NotificationType }[] = [
  { label: 'Login', value: 'login' },
  { label: 'Booking Created', value: 'booking_created' },
  { label: 'Booking Confirmed', value: 'booking_confirmed' },
  { label: 'Booking Cancelled', value: 'booking_cancelled' },
  { label: 'Wallet Credit', value: 'wallet_credit' },
  { label: 'Wallet Debit', value: 'wallet_debit' },
  { label: 'Payment Success', value: 'payment_success' },
  { label: 'Payment Failed', value: 'payment_failed' },
  { label: 'Reminder', value: 'reminder' },
  { label: 'General', value: 'general' },
];

export const getColumns = (
  currentPage: number,
  rows: number,
  userNamesMap?: Record<string, string>
) => [
  {
    header: 'S.No.',
    accessor: '_index',
    render: (_row: unknown, index?: number) => (currentPage - 1) * rows + (index ?? 0) + 1,
  },
  {
    header: 'User',
    accessor: 'userId',
    render: (row: any) => {
      if (!row.userId) return '-';
      const name = userNamesMap?.[row.userId];
      return name ?? '...';
    },
  },
  {
    header: 'Type',
    accessor: 'type',
    render: (row: any) => (
      <Chip size="small" label={row.type ?? '-'} variant="outlined" />
    ),
  },
  {
    header: 'Title',
    accessor: 'title',
  },
  {
    header: 'Message',
    accessor: 'message',
    render: (row: any) => {
      const msg = row.message ?? '';
      return msg.length > 50 ? `${msg.slice(0, 50)}...` : msg || '-';
    },
  },
  {
    header: 'Read',
    accessor: 'isRead',
    render: (row: any) => (row.isRead ? 'Yes' : 'No'),
  },
  {
    header: 'Created',
    accessor: 'createdAt',
    render: (row: any) =>
      row.createdAt ? moment(row.createdAt).format('DD/MM/YYYY HH:mm') : '-',
  },
];
